import React from 'react';
import styled from '@emotion/styled';
import { MapType, markerDetailsType, SurveySiteType } from '../../types/dataTypes';
import { BREAKPOINTS, COLORS_BASE, STYLES } from '../../utils/consts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faMagnifyingGlassPlus, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { ButtonContainerStyle, ButtonStyle, CloseButton, IconTextContainerStyle } from '../../styles/styles';
import { TEXT_SURVEY_DATA_DETAILS, TEXT_SURVEY_SIDEBAR } from '../../utils/text';
import Button from '../Shared/Button';

type DetailedPopupProps = {
  details: markerDetailsType[];
  onClose: () => void;
  map: MapType;
  layerName: string;
};

function DetailedPopup({ details, onClose, map, layerName }: DetailedPopupProps) {
 
  return (
    <CardContainer>
      <CloseButton onClick={onClose} >
        <FontAwesomeIcon icon={faClose} />
      </CloseButton>
      <IconTextContainerStyle style={{marginRight: '25px'}}>
        <FontAwesomeIcon icon={faLocationDot} />
        {layerName}
      </IconTextContainerStyle>
      <GridContainer>
        {details.map((detail, index) => (
          <GridItem key={index}>
            <span>{detail.label}</span>
            <span>{detail.value} {detail.unit}</span>
          </GridItem>
        ))}
      </GridContainer>
    </CardContainer>
  );
};

const CardContainer = styled.div`  
  position: fixed;
  left: ${STYLES.SIDEBAR_WIDTH+40}px;
  bottom: 60px;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  z-index: 1000;
  color: ${COLORS_BASE.BRAND.DARKER};

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    left: 12px;
    right: 12px;
    bottom: 92px;
    width: auto;
    max-width: calc(100vw - 24px);
  }
`;

const GridContainer = styled.div`
  margin-top: 30px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 8px;
  align-items: center;
  text-align: left;
`;

const GridItem = styled.div`
  display: contents;

  & > svg {
    grid-column: 1;
  }

  & > span:nth-of-type(1) {
    grid-column: 2;
  }
`;

export default DetailedPopup;